import { render, staticRenderFns } from "./FormMiembro.vue?vue&type=template&id=2126fa0a&scoped=true&"
import script from "./FormMiembro.vue?vue&type=script&lang=js&"
export * from "./FormMiembro.vue?vue&type=script&lang=js&"
import style0 from "./FormMiembro.vue?vue&type=style&index=0&id=2126fa0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2126fa0a",
  null
  
)

export default component.exports